import { Component, inject } from '@angular/core';
import { ThemeService } from 'theme-lib';
import { ThemeCustomizerService } from '../../services/theme-customizer.service';

@Component({
  selector: 'app-theme-customizer',
  standalone: true,
  imports: [],
  templateUrl: './theme-customizer.component.html',
})
export class ThemeCustomizerComponent {
  private readonly _themeService = inject(ThemeService);

  readonly _customizer = inject(ThemeCustomizerService);
  readonly isOpen = this._customizer.isOpen;
  readonly currentPrefs = this._customizer.currentPrefs;
  readonly accentPresets = this._customizer.accentPresets;
  readonly fontSizeOptions = this._customizer.fontSizeOptions;
  readonly widthOptions = this._customizer.widthOptions;
  /** Use the shared signal — single source of truth across all components */
  readonly isDark = this._customizer.dark;

  setAccent(key: string): void {
    this._customizer.setAccent(key);
  }

  setFontSize(key: 'small' | 'medium' | 'large'): void {
    this._customizer.setFontSize(key);
  }

  setWidth(key: 'narrow' | 'standard' | 'wide'): void {
    this._customizer.setWidth(key);
  }

  toggleTheme(): void {
    this._themeService.toggleTheme();
    // reapplyAccent() calls syncDark() internally, keeping _customizer.dark in sync
    this._customizer.reapplyAccent();
  }

  close(): void {
    this._customizer.close();
  }
}
